export default __webpack_public_path__ + "static/media/gallery23.33a386ed.webp";